<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card elevation="12">
          <v-toolbar color="primary">
            <v-toolbar-title>Iniciar sesion</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-form ref="form" v-model="valid" validate-on="lazy" @submit.prevent="login" @keydown.enter.prevent="login">
              <v-text-field
                v-model="userInfo.username"
                :rules="requiredFieldRule"
                label="Nombre de Usuario"
                required
              />
              <v-text-field
                v-model="userInfo.password"
                type="password"
                autocomplete="on"
                :rules="requiredFieldRule"
                label="Contrasena"
                required
              />
              <v-alert
                v-if="errorMessage"
                class="mb-4"
                density="compact"
                type="error"
                variant="tonal"
              >
                {{ errorMessage }}
              </v-alert>
              <div class="filter-actions">
                <v-btn color="primary" type="submit" :disabled="loading" :loading="loading">Ingresar</v-btn>
                <v-btn color="secondary" type="button" variant="text" @click="clearForm">Limpiar Formulario</v-btn>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Login',
  data: () => {
    return {
      valid: true,
      userInfo: {
        username: '',
        password: '',
        role: ''
      },
      loading: false,
      errorMessage: '',
      requiredFieldRule: [v => !!v || 'Campo requerido']
    }
  },
  computed: {
    ...mapGetters('authModule', ['isAuthenticated'])
  },
  methods: {
    async login () {
      if (this.loading) return
      const validation = await this.$refs.form.validate()
      if (!validation.valid) {
        return
      }
      this.loading = true
      this.errorMessage = ''
      this.$store.dispatch('authModule/login', this.userInfo)
        .then(() => {
          this.$router.push(this.$store.getters['authModule/homeRoute'])
        }).catch(() => {
          this.userInfo.password = ''
          this.errorMessage = 'Usuario o contrasena incorrectos.'
        }).finally(() => {
          this.loading = false
        })
    },
    clearForm () {
      this.$refs.form.reset()
      this.errorMessage = ''
    }
  }
}
</script>
